<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer012">
<p class="basic-paragraph"><span class="charoverride4"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride4">Acknowledgments</span></h1>
<p class="basic-paragraph3"><span class="charoverride8"><br class="calibre2"/></span></p>
<p class="basic-paragraph3"><span class="charoverride8">Once again, I owe much to many for all manner of assistance during this project. First and foremost, Marge Easley, my wife, my muse, my “in-house” editor, kept me on track and daughter Kate provided sage advice on a central, young adult character. Thanks always to the brilliant crew at Poisoned Pen Press, especially editors Barbara Peters and Annette Rogers, who provided invaluable suggestions and insights. A group of talented Portland writers—Lisa Alber, Debby Dodds, Alison Jakel, Janice Maxon, and LeeAnn McLennan—critiqued this manuscript and let me hang out with them, too. Thanks again, guys! I owe a debt of gratitude to Dr. Shawn Easley, who advised me on several civil aviation issues that arose in this book. If any inaccuracies crept in, it’s on me not him. In a similar vein, barrister and former Navy fighter pilot John advised me on the legal scrapes Cal got himself into this time around, which were legion and gnarly. Thanks, John!</span></p>
<p class="basic-paragraph7"><span class="charoverride8">Finally, and significantly, I took inspiration for this book from courageous people everywhere who are standing up to greed, hatred, and racism.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?5ddbc5f9